import { StrictMode, Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { SessionProvider } from './lib/session';
import { OberflaecheProvider } from './ui';
import App from './App';
import './design/tokens.css';
import './styles.css';

// Kundenportal unter /portal: eigene Oberfläche ohne Mandantensitzung (Portalkunden sind keine Mitglieder)
const Portal = lazy(() => import('./portal/Portal'));
const istPortal = window.location.pathname === '/portal' || window.location.pathname.startsWith('/portal/');

createRoot(document.getElementById('root')!).render(istPortal ? (
  <StrictMode>
    <OberflaecheProvider>
      <Suspense fallback={null}><Portal /></Suspense>
    </OberflaecheProvider>
  </StrictMode>
) : (
  <StrictMode>
    <BrowserRouter>
      <SessionProvider>
        <OberflaecheProvider>
          <App />
        </OberflaecheProvider>
      </SessionProvider>
    </BrowserRouter>
  </StrictMode>
));
